import type { IStoreOptionWithDetails } from "../../../../services/store/select-options";

export const formatStorePostalCode = (postalCode?: string | null): string => {
  const rawPostalCode = postalCode?.replace(/\D/g, "") ?? "";
  if (rawPostalCode.length !== 8) return postalCode ?? "";
  return `${rawPostalCode.substring(0, 5)}-${rawPostalCode.substring(5)}`;
};

export const toTitleCase = (text: string): string => {
  if (!text) return "";
  const lowerText = text.toLowerCase();
  return lowerText
    .split(/\s+/)
    .map(word => {
      if (!word) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

export const formatStoreNickname = (
  storeCode: string,
  storeOptionsMap: Map<string, IStoreOptionWithDetails>
): string => {
  const store = storeOptionsMap.get(storeCode) as IStoreOptionWithDetails | undefined;
  if (!store) return "";

  const locationParts = [
    store.city?.trim(),
    store.neighborhood?.trim(),
  ]
    .filter((part): part is string => !!part)
    .map(part => toTitleCase(part));

  const baseNickname = locationParts.join(" ");
  const statePart = store.state?.trim();

  const nicknameWithState = baseNickname
    ? statePart
      ? `${baseNickname} - ${statePart}`
      : baseNickname
    : statePart ?? "";

  if (nicknameWithState) {
    return nicknameWithState.replace(/\s{2,}/g, " ").trim();
  }

  const fallbackNickname = store.nickname || store.label || "";
  return toTitleCase(fallbackNickname);
};

export const formatStoreAddress = (
  storeCode: string,
  storeOptionsMap: Map<string, IStoreOptionWithDetails>
): string => {
  const store = storeOptionsMap.get(storeCode) as IStoreOptionWithDetails | undefined;
  if (!store) return "";

  const formattedPostalCode = formatStorePostalCode(store.postalCode);
  const addressParts = [
    `Loja ${String(store.value).trim()}`,
    toTitleCase(store.address?.trim() || ""),
    toTitleCase(store.neighborhood?.trim() || ""),
    toTitleCase(store.city?.trim() || ""),
    formattedPostalCode?.trim(),
  ].filter(part => !!part && part !== "-");

  return addressParts.join(" - ");
};